import FitAndRideView from './TechnologyView'

export default FitAndRideView